// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/font-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/font-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'pbghFont';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}
@font-face {
    font-family: 'pbghFontBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'pbghFont';
}



@media (max-width: 1300px) {

}

@media (max-width: 900px) {

}

@media (max-width: 780px) {




}


@media (max-width: 600px) {


    .main-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-top: 45px;
    }


}

@media (min-width: 601px) {
    .sidebar {
        display: flex !important;
        position: fixed;
        background-color: white;
        z-index: 1;
        margin-top: 50px;
    }

    .main-content {
        width: calc(100% - 240px);
        position: absolute;
        left: 0;
        padding: 0px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,2DAAgD;AACpD;AACA;IACI,2BAA2B;IAC3B,2DAA+C;AACnD;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,uBAAuB;AAC3B;;;;AAIA;;AAEA;;AAEA;;AAEA;;AAEA;;;;;AAKA;;;AAGA;;;IAGI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,gBAAgB;IACpB;;;AAGJ;;AAEA;IACI;QACI,wBAAwB;QACxB,eAAe;QACf,uBAAuB;QACvB,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,OAAO;QACP,iBAAiB;IACrB;AACJ","sourcesContent":["@font-face {\n    font-family: 'pbghFont';\n    src: url('fonts/font-Light.woff') format('woff');\n}\n@font-face {\n    font-family: 'pbghFontBold';\n    src: url('fonts/font-Bold.woff') format('woff');\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'pbghFont';\n}\n\n\n\n@media (max-width: 1300px) {\n\n}\n\n@media (max-width: 900px) {\n\n}\n\n@media (max-width: 780px) {\n\n\n\n\n}\n\n\n@media (max-width: 600px) {\n\n\n    .main-content {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        margin-top: 45px;\n    }\n\n\n}\n\n@media (min-width: 601px) {\n    .sidebar {\n        display: flex !important;\n        position: fixed;\n        background-color: white;\n        z-index: 1;\n        margin-top: 50px;\n    }\n\n    .main-content {\n        width: calc(100% - 240px);\n        position: absolute;\n        left: 0;\n        padding: 0px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
